export type RecentlyUsedFont = {
    family: string;
    source: FontSources;
};

export enum FontSources {
    GOOGLE = "google",
    WEBFONT = "webFont",
}
